import { createAsyncThunk } from "@reduxjs/toolkit";
import { type TrainingProgram, type TrainingProgramDetails } from "@fitness-app/data-models/entities/TrainingProgram";
import { type Json } from "@fitness-app/supabase";
import { removeWorkoutFromProgramSchedule } from "@fitness-app/utils/src/programs/programSchedule";

import { type AsyncThunkCreator } from "../../../index";
import { getCurrentProgram } from "../selectors/getCurrentProgram";
import { PROGRAM_BUILDER_REDUCER_NAME } from "../types";

type Payload = {
  programId: string;
  workoutId: string;
};

export type RemoveWorkoutFromProgramResult = {
  details: TrainingProgramDetails;
  program: TrainingProgram;
};

export const removeWorkoutFromProgram = createAsyncThunk<
  RemoveWorkoutFromProgramResult,
  Payload,
  AsyncThunkCreator<string>
>(
  `${PROGRAM_BUILDER_REDUCER_NAME}/removeWorkoutFromProgram`,
  async ({ programId, workoutId }, { rejectWithValue, getState, extra: { db } }) => {
    const currentProgram = getCurrentProgram(getState());

    const updatedWorkouts = currentProgram.details.workouts.filter((workout) => workout.id !== workoutId);
    const updatedDefaultSchedule = removeWorkoutFromProgramSchedule(currentProgram.program.defaultSchedule, workoutId);
    const updatedAt = new Date().toISOString();

    const { data, error } = await db.rpc("remove_training_program_workout", {
      p_default_schedule: updatedDefaultSchedule as unknown as Json,
      p_program_id: programId,
      p_updated_at: updatedAt,
      p_workouts: updatedWorkouts as unknown as Json,
    });

    if (error) {
      return rejectWithValue(error.message);
    }

    return data as unknown as RemoveWorkoutFromProgramResult;
  },
);
